import _ from 'lodash';

export default function SelecaoSubcontextoController(
  $q,
  $state,
  acessoService,
  promiseTracker
) {
  const vm = this;
  vm.trackers = { carregando: promiseTracker() };

  (() => {
    const promise = acessoService.meusAcessosPorSubcontexto().then((subcontextosConfigs) => {
      if (_.isEmpty(subcontextosConfigs)) {
        return $q.reject();
      }

      vm.subcontextoConfig = subcontextosConfigs[0];
    });

    vm.trackers.carregando.addPromise(promise);
    return promise;
  })();

  vm.selectOption = (access) => {
    const values = {
      [vm.subcontextoConfig.id]: access.subcontextId
    };

    const params = {
      SUBCONTEXTO_HASH: btoa(JSON.stringify(values))
    };

    return $state.go('main.entidade.selected.sistema.selected.subcontexto.selected.visaoGeralSubcontexto', params);
  };
}

SelecaoSubcontextoController.$inject = [
  '$q',
  '$state',
  'AcessoService',
  'promiseTracker'
];
